import React, {Component, useState, useEffect} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom';
import EmailContent from '../components/EmailContent'; 
import axios from 'axios'; 
import Header from '../common/Header'; 
import Footer from '../common/Footer';
import PageHeader from '../components/PageHeader'; 
import withRouter from '../components/withRouter';
import { Helmet } from "react-helmet";
import {  base_url} from '../common/Constants';

class Email extends React.Component{

    constructor(){
        super();  
    }
 
    render()
    { 
        const content = JSON.parse(localStorage.getItem("content"));
        const metas = JSON.parse(localStorage.getItem("metas"));
       
        return (
                 <div className="body-block">
 

                <Header/> 

                 <div className="page-block Contact">
    <div className="barrier">
      <div
        className="pages-headline aos-init aos-animate"
        data-aos="fade-up"
        data-aos-duration="2000"    
      >
        <div className="pages-breadcumbs">
          <div className="crumbs">
            <div className="crumb">
              <a href="/" className="nuxt-link-active">HOME</a>
            </div>
            <div className="crumb">
              <a href="/" className="nuxt-link-active">
                <span className="crumb-slash">/</span>Email
              </a>
            </div>
            <div className="crumb"></div>
          </div>
        </div>
                 <EmailContent  content={JSON.parse(localStorage.getItem("content"))}  companies={JSON.parse(localStorage.getItem("companies"))}  />  

                 </div>
                 </div>
                <Footer/>
                
      
        </div>
        </div>
       
        )
    }

}
export default withRouter(Email);;